<template>
  <div style="max-width: 700px; margin: auto" class="">
    <Permissions :user-id="id">
      <div class="card">
        <div class="card-content">
          <UserSettings :user="user" />
        </div>
      </div>
      <div class="mt-6 py-4 card has-text-centered">
        <b-button v-if="!showInfo" size="is-medium" :loading="isLoading" :disabled="isLoading" @click="resetPW">
          {{ $t("resetPassword") }}
        </b-button>
        <p v-else>
          {{ $t("pwResetInfo") }}
        </p>
      </div>
      <div class="mt-6 py-4 card">
        <b>Subscription details:</b>
        <ul style="list-style-type: square; list-style-position: inside">
          <li>Type: {{ subscriptionDetails.type }}</li>
          <li>Plan: {{ subscriptionDetails.plan }}</li>
          <li>Monthly price: {{ subscriptionDetails.amount }}</li>
        </ul>
      </div>
    </Permissions>
  </div>
</template>

<script>
import UserSettings from "@/components/UserSettings";
import { auth, db } from "@/firebase";
import Permissions from "@/components/Permissions";

export default {
  name: "UserAccount",
  components: {
    UserSettings,
    Permissions,
  },
  data() {
    return {
      user: {
        firstName: "",
        lastName: "",
        mobileNumber: "",
        telephoneNumber: "",
        title: "",
      },
      subscriptionDetails: {},
      isLoading: false,
      showInfo: false,
    };
  },
  computed: {
    id() {
      if (this.$store.getters.getCurrentUser) {
        return this.$store.getters.getCurrentUser.uid;
      }
      return null;
    },
  },
  created() {
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        // console.log(user);
        this.$bind("user", db.collection("user_information").doc(user.uid));
        this.user = {
          firstName: "",
          lastName: "",
          mobileNumber: "",
          telephoneNumber: "",
          title: "",
        };
        let orgDocSnapshot = await db.collection("organizations").doc(sessionStorage.organizationId).get();
        this.subscriptionDetails = orgDocSnapshot.data().subscriptionDetails;
        console.log("user:", orgDocSnapshot.data().subscriptionDetails);
      } else {
        this.user = {
          firstName: "",
          lastName: "",
          mobileNumber: "",
          telephoneNumber: "",
          title: "",
        };
      }
    });
  },
  methods: {
    async resetPW() {
      this.isLoading = true;
      try {
        await auth.sendPasswordResetEmail(this.$store.getters.getCurrentUser.email);
        this.$buefy.toast.open({
          type: "is-success",
          message: this.$t("resetPWMail"),
        });
        this.showInfo = true;
      } catch (err) {
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$t(err.code),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>

<style></style>
